import config from 'SRC/config/config.yaml'

export const adFiltersLabels = config.filters.adFiltersLabels
